// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 767.98px){.mission-list{flex-direction:column}}.mission-card{border:1px solid #eff6ff;margin-bottom:1.2rem}.mission-card-wrapper{height:240px}.mission-card-header,.mission-card-body,.mission-card-footer{padding:0 0.5rem}.mission-card-header,.mission-card-footer{background-color:#eff6ff}.mission-card-header p,.mission-card-footer p{margin-block:0.3rem}.mission-card-body{text-align:center}.mission-card-body-title{font-weight:600;line-height:1.2;color:#104182}\n", ""]);
// Exports
module.exports = exports;
